import {
    LastLessonClient
} from "../clients/LastLessonClient"


export const LastLessonModule = {
    namespaced: true,

    state: {
        lastViewedLesson: Object
    },

    mutations: {
        SET_LAST_LESSON(state, payload) {
            state.lastViewedLesson = payload
        }

    },

    actions: {
        getLastLesson({
            commit
        }) {
            LastLessonClient.getLastLesson().then((response) => {

                commit('SET_LAST_LESSON',
                    response.data
                )
            })
        }
    }
};